var initScrollAnimations = function() {
    var controllerScroll = new ScrollMagic.Controller();

    jQuery('.sr').each(function() {
        var element = jQuery(this);
        var offset  = element.offset().top;
        var windowHeight  = jQuery(window).height();
        var scene   = new ScrollMagic.Scene({
            triggerHook: "onLeave",
            offset: offset - ( windowHeight * 0.85 ),
            reverse: false
        });
        scene.on('start', function(e) {
            if (e.scrollDirection != 'REVERSE') {
                element.trigger('reveal');
                scene.remove();
            }
        });
        scene.addTo(controllerScroll);
    });
    jQuery('.page-container').data('scrollController', controllerScroll);
};


/*
	Pour l'utilisation :
	- Ajouter la classe "sr" au bloc que vous souhaitez révéler
	- Ajouter une classe complémentaire pour utiliser une des aniomations prédéfinies

		- "sr--word" : pour réveler un texte sur une seule ligne. Il faut également
		imbriquer le texte dans un span
		exemple. <h2 class="sr sr--word"><span>Mon texte</span></h2>

		- "sr--line" : anime toutes les lignes des éléments P inclus

		- "sr--add-class" : ajoute une classe à tous les sous-éléments taggués
		avec la classe "sr--item". Vous pouvez ensuite effectuer les réglages suivants
		à l'aide d’attributs sur le bloc "sr--add-class" :
			- "data-class" : le nom de la classe ajoutée à chaque élément "sr--item".
			  Défaut : "sr--show"
			- "data-duration" : entre 0 et 1. Défini la zone de déclenchement. Défaut : 0.5
			- "data-delay" : en secondes. Défini le délai d'ajout de la classe sur chaque itération
			  des éléments "sr--item"
*/

var scrollRevealHandler = function() {
    var element = jQuery(this);

    if (element.hasClass('is-revealed'))
        return;

    if (element.is('.sr--word')) {
        splitTitle = new SplitText(element.find('span:not(.nowrap)'),{
            type:       'words',
            wordsClass: 'split-word'
        });

        lines = element.find('span');
        words = element.find('.split-word');

        words.css({
            opacity: 0
        });
        element.find('span').css({
            opacity: 1
        });

        element.addClass('is-revealed');

        tl = new TimelineLite();
        tl.pause();

        lines.each(function(index) {
            var line = jQuery(this);
            tl.fromTo(line.find('.split-word'), 0.8, {
                alpha: 0,
                top: line.height()
            }, {
                alpha: 1,
                top: 0,
                ease: Power3.easeOut
            }, 0 + (index * 0.1));
        });
        tl.call(function() {
            splitTitle.revert();
        });
        tl.play();

    } else if (element.is('.sr--line')) {

        splitTitle = new SplitText(element.find('p'),{
            type:       'lines',
            linesClass: 'split-line'
        });

        lines = element.find('.split-line');

        lines.css({
            opacity: 0
        });
        element.find('p').css({
            opacity: 1
        });

        element.addClass('is-revealed');

        tl = new TimelineLite();
        tl.pause();

        lines.each(function(index) {
            var line = jQuery(this);
            tl.fromTo( line, 0.8, {
                alpha: 0,
                top: line.height()
            }, {
                alpha: 1,
                top: 0,
                ease: Power3.easeOut
            }, 0 + (index * 0.1));
        });
        tl.call(function() {
            splitTitle.revert();
        });
        tl.play();

    } else if (element.is('.editor-text')) {
        p = jQuery(this).find('p, li');

        element.addClass('is-revealed');

        p.css({
            opacity: 0
        });

        tl = new TimelineLite();
        tl.pause();

        p.each(function(index) {
            tl.fromTo(jQuery(this), 0.8, {
                alpha: 0,
                y: 20
            }, {
                alpha: 1,
                y: 0,
                ease: Power3.easeOut
            }, 0 + (index * 0.1));
        });
        tl.play();

    } else if (element.is('.sr--add-class')) {
        element.addClass('is-revealed');

        var item = jQuery(this).find('.sr--item');

        var duration       = ( element.data('duration') || 0.5 );
        var delay          = ( element.data('delay') || 0.2 );
        var animationClass = ( element.data('class') || 'sr--show' );

        TweenMax.staggerTo(item, duration, {className: '+=' + animationClass}, delay);
    }
};